import { buildProps as e, definePropType as o } from "./index601.js";
const r = e({
  cell: {
    type: o(Object)
  }
});
export {
  r as basicCellProps
};
